// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./fonts/roboto-condensed-latin-300-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("./fonts/roboto-condensed-latin-300-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("./fonts/roboto-condensed-latin-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("./fonts/roboto-condensed-latin-400-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("./fonts/roboto-condensed-latin-500-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("./fonts/roboto-condensed-latin-500-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("./fonts/roboto-condensed-latin-600-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("./fonts/roboto-condensed-latin-600-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("./fonts/roboto-condensed-latin-700-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_9___ = new URL("./fonts/roboto-condensed-latin-700-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_10___ = new URL("./fonts/noto-sans-latin-300-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_11___ = new URL("./fonts/noto-sans-latin-300-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_12___ = new URL("./fonts/noto-sans-latin-400-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_13___ = new URL("./fonts/noto-sans-latin-400-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_14___ = new URL("./fonts/noto-sans-latin-500-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_15___ = new URL("./fonts/noto-sans-latin-500-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_16___ = new URL("./fonts/noto-sans-latin-600-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_17___ = new URL("./fonts/noto-sans-latin-600-normal.woff", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_18___ = new URL("./fonts/noto-sans-latin-700-normal.woff2", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_19___ = new URL("./fonts/noto-sans-latin-700-normal.woff", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
var ___CSS_LOADER_URL_REPLACEMENT_9___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_9___);
var ___CSS_LOADER_URL_REPLACEMENT_10___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_10___);
var ___CSS_LOADER_URL_REPLACEMENT_11___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_11___);
var ___CSS_LOADER_URL_REPLACEMENT_12___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_12___);
var ___CSS_LOADER_URL_REPLACEMENT_13___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_13___);
var ___CSS_LOADER_URL_REPLACEMENT_14___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_14___);
var ___CSS_LOADER_URL_REPLACEMENT_15___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_15___);
var ___CSS_LOADER_URL_REPLACEMENT_16___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_16___);
var ___CSS_LOADER_URL_REPLACEMENT_17___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_17___);
var ___CSS_LOADER_URL_REPLACEMENT_18___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_18___);
var ___CSS_LOADER_URL_REPLACEMENT_19___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_19___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Roboto Condensed - self-hosted via src/fonts/ (copied from @fontsource/roboto-condensed) */

/* Weight 300 — Light */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_0___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_1___}) format("woff");
}

/* Weight 400 — Regular */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_2___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_3___}) format("woff");
}

/* Weight 500 — Medium */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 500;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format("woff");
}

/* Weight 600 — SemiBold */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_7___}) format("woff");
}

/* Weight 700 — Bold */
@font-face {
    font-family: "Roboto Condensed";
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_8___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_9___}) format("woff");
}

/* Noto Sans - self-hosted via src/fonts/ (copied from @fontsource/noto-sans) */

/* Weight 300 — Light */
@font-face {
    font-family: "Noto Sans";
    font-style: normal;
    font-display: swap;
    font-weight: 300;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_10___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_11___}) format("woff");
}

/* Weight 400 — Regular */
@font-face {
    font-family: "Noto Sans";
    font-style: normal;
    font-display: swap;
    font-weight: 400;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_12___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_13___}) format("woff");
}

/* Weight 500 — Medium */
@font-face {
    font-family: "Noto Sans";
    font-style: normal;
    font-display: swap;
    font-weight: 500;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_14___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_15___}) format("woff");
}

/* Weight 600 — SemiBold */
@font-face {
    font-family: "Noto Sans";
    font-style: normal;
    font-display: swap;
    font-weight: 600;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_16___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_17___}) format("woff");
}

/* Weight 700 — Bold */
@font-face {
    font-family: "Noto Sans";
    font-style: normal;
    font-display: swap;
    font-weight: 700;
    src:
        url(${___CSS_LOADER_URL_REPLACEMENT_18___}) format("woff2"),
        url(${___CSS_LOADER_URL_REPLACEMENT_19___}) format("woff");
}

/* App-wide default font */
body {
    font-family: "Roboto Condensed", Arial, sans-serif;
}
`, "",{"version":3,"sources":["webpack://./src/fonts.css"],"names":[],"mappings":"AAAA,6FAA6F;;AAE7F,uBAAuB;AACvB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,yBAAyB;AACzB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,wBAAwB;AACxB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,0BAA0B;AAC1B;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,sBAAsB;AACtB;IACI,+BAA+B;IAC/B,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;8DAEwE;AAC5E;;AAEA,+EAA+E;;AAE/E,uBAAuB;AACvB;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;+DAEiE;AACrE;;AAEA,yBAAyB;AACzB;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;+DAEiE;AACrE;;AAEA,wBAAwB;AACxB;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;+DAEiE;AACrE;;AAEA,0BAA0B;AAC1B;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;+DAEiE;AACrE;;AAEA,sBAAsB;AACtB;IACI,wBAAwB;IACxB,kBAAkB;IAClB,kBAAkB;IAClB,gBAAgB;IAChB;;+DAEiE;AACrE;;AAEA,0BAA0B;AAC1B;IACI,kDAAkD;AACtD","sourcesContent":["/* Roboto Condensed - self-hosted via src/fonts/ (copied from @fontsource/roboto-condensed) */\n\n/* Weight 300 — Light */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src:\n        url(\"./fonts/roboto-condensed-latin-300-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-300-normal.woff\") format(\"woff\");\n}\n\n/* Weight 400 — Regular */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src:\n        url(\"./fonts/roboto-condensed-latin-400-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-400-normal.woff\") format(\"woff\");\n}\n\n/* Weight 500 — Medium */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 500;\n    src:\n        url(\"./fonts/roboto-condensed-latin-500-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-500-normal.woff\") format(\"woff\");\n}\n\n/* Weight 600 — SemiBold */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 600;\n    src:\n        url(\"./fonts/roboto-condensed-latin-600-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-600-normal.woff\") format(\"woff\");\n}\n\n/* Weight 700 — Bold */\n@font-face {\n    font-family: \"Roboto Condensed\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src:\n        url(\"./fonts/roboto-condensed-latin-700-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/roboto-condensed-latin-700-normal.woff\") format(\"woff\");\n}\n\n/* Noto Sans - self-hosted via src/fonts/ (copied from @fontsource/noto-sans) */\n\n/* Weight 300 — Light */\n@font-face {\n    font-family: \"Noto Sans\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 300;\n    src:\n        url(\"./fonts/noto-sans-latin-300-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/noto-sans-latin-300-normal.woff\") format(\"woff\");\n}\n\n/* Weight 400 — Regular */\n@font-face {\n    font-family: \"Noto Sans\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 400;\n    src:\n        url(\"./fonts/noto-sans-latin-400-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/noto-sans-latin-400-normal.woff\") format(\"woff\");\n}\n\n/* Weight 500 — Medium */\n@font-face {\n    font-family: \"Noto Sans\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 500;\n    src:\n        url(\"./fonts/noto-sans-latin-500-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/noto-sans-latin-500-normal.woff\") format(\"woff\");\n}\n\n/* Weight 600 — SemiBold */\n@font-face {\n    font-family: \"Noto Sans\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 600;\n    src:\n        url(\"./fonts/noto-sans-latin-600-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/noto-sans-latin-600-normal.woff\") format(\"woff\");\n}\n\n/* Weight 700 — Bold */\n@font-face {\n    font-family: \"Noto Sans\";\n    font-style: normal;\n    font-display: swap;\n    font-weight: 700;\n    src:\n        url(\"./fonts/noto-sans-latin-700-normal.woff2\") format(\"woff2\"),\n        url(\"./fonts/noto-sans-latin-700-normal.woff\") format(\"woff\");\n}\n\n/* App-wide default font */\nbody {\n    font-family: \"Roboto Condensed\", Arial, sans-serif;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
